/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
var referenceCounts = {
  'og:description': 0,
  'og:image': 0
};

angular.module('bulbApp.openGraphModule')
.directive('bulbOpenGraph', ['openGraphValues', 'OPEN_GRAPH', bulbOpenGraph])

function bulbOpenGraph (openGraphValues, OPEN_GRAPH) {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {

      if (!angular.isString(attrs.bulbOpenGraph)) {
        throw 'bulb-open-graph\'s value must be a string';
      }

      switch (attrs.bulbOpenGraph) {
        case 'og:description':
          referenceCounts['og:description']++;
          scope.$watch(function() {
            return element.text();
          }, function(newDescription) {
            openGraphValues['og:description'] = newDescription;
          });

          scope.$on(
            '$destroy',
            function () {
              referenceCounts['og:description']--;
              if (referenceCounts['og:description'] <= 0) {
                referenceCounts['og:description'] = 0;
                delete openGraphValues['og:description'];
              }
            }
          );
          break;

        case 'og:image':
          referenceCounts['og:image']++;
          attrs.$observe('src', function(src) {
            openGraphValues['og:image'] = src;
          });

          if (attrs.bulbOpenGraphImageWidth) {
            attrs.$observe('bulbOpenGraphImageWidth', function(width) {
              if (width) {
                openGraphValues['og:image:width'] = width;
              } else {
                delete openGraphValues['og:image:width'];
              }
            });
          } else {
            delete openGraphValues['og:image:width'];
          }

          if (attrs.bulbOpenGraphImageHeight) {
            attrs.$observe('bulbOpenGraphImageHeight', function(height) {
              if (height) {
                openGraphValues['og:image:height'] = height;
              } else {
                delete openGraphValues['og:image:height'];
              }
            });
          } else {
            delete openGraphValues['og:image:height'];
          }

          scope.$on(
            '$destroy',
            function () {
              referenceCounts['og:image']--;
              if (referenceCounts['og:image'] <= 0) {
                referenceCounts['og:image'] = 0;
                openGraphValues['og:image'] = OPEN_GRAPH.defaultImage.url;
                openGraphValues['og:image:width'] = OPEN_GRAPH.defaultImage.width;
                openGraphValues['og:image:height'] = OPEN_GRAPH.defaultImage.height;
              }
            }
          );
          break;
        default:
          throw 'unrecognized value for bulb-open-graph.  Should be "og:description" or "og:image"';

      }
    }
  };
}




